<template>
  <div class="px-8">
    <p class="md:mt-8">Работаем для вас <span class="text-white">24 часа в сутки.</span></p>
    <div class="my-2">
      <a href="tel:88007754433" class="uppercase text-3xl md:text-5xl tracking-widest"> 8-800-775-44-33 </a>
    </div>
    <div class="flex md:justify-center mt-4">
      <a href="https://t.me/Concierge_and_lifestyle_services" target="_blank">
        <img src="../assets/images/svg/tg.svg" alt="Telegram" class="h-auto pr-5" />
      </a>

      <a href="https://wa.me/74956264812" target="_blank">
        <img src="../assets/images/svg/whatsApp.svg" alt="WhatsApp" class="h-auto" />
      </a>
    </div>
  </div>
</template>

<style scoped>
a {
  background: linear-gradient(180deg, #fff 0%, #787878 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
